<p *ngIf="(matrix.per_participant_fees.length === 0) && (matrix.per_participant_add_ons.length === 0) && (matrix.per_booking_fees.length === 0) && (matrix.per_booking_add_ons.length === 0)">
  <b>No Fees Configured</b>
</p>

<ng-container *ngIf="matrix.per_participant_fees.length > 0">
  <label><b>Per-Participant Fees</b></label>

  <table class="table table-sm table-bordered">
    <tr *ngFor="let fee of matrix.per_participant_fees">
      <th>
        {{ fee.name }}
        <ng-container *ngIf="fee.includes_entry">
          <br>
          <span class="text-muted">Includes Entry</span>
        </ng-container>
        <ng-container *ngIf="fee.sell_voucher_via_pos">
          <br>
          <span class="text-muted">For Sale in POS</span>
        </ng-container>
      </th>
      <td>
        {{ orgConfig.getCurrencySymbol() }}{{ fee.fee }}
      </td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="matrix.per_participant_add_ons.length > 0">
  <label><b>Per-Participant Add-Ons</b></label>

  <table class="table table-sm table-bordered">
    <tr *ngFor="let addOn of matrix.per_participant_add_ons">
      <th>
        {{ addOn.name }}
      </th>
      <td>
        {{ orgConfig.getCurrencySymbol() }}{{ addOn.fee }}
        <ng-container *ngIf="addOn.allow_multiple_copies">
          <br>
          <span class="text-muted">
            Allows multiple copies (max {{ addOn.max_copies }},
            via {{ addOn.multiple_copies_input_type === 'dropdown' ? 'dropdown' : 'number input' }})
          </span>
        </ng-container>
      </td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="matrix.per_booking_fees.length > 0">
  <label><b>Per-Booking Fees</b></label>

  <table class="table table-sm table-bordered">
    <tr *ngFor="let fee of matrix.per_booking_fees">
      <th>
        {{ fee.name }}
        <ng-container *ngIf="fee.includes_entry">
          <br>
          <span class="text-muted">Includes Entry</span>
        </ng-container>
        <ng-container *ngIf="fee.sell_voucher_via_pos">
          <br>
          <span class="text-muted">For Sale in POS</span>
        </ng-container>
      </th>
      <td>
        {{ orgConfig.getCurrencySymbol() }}{{ fee.fee }}
        <ng-container *ngIf="fee.included_participants">
          (Max {{ fee.included_participants }} Participants)
          <ng-container *ngIf="fee.additional_participant_fee">
            <br>
            {{ orgConfig.getCurrencySymbol() }}{{ fee.additional_participant_fee }} Per Additional Participant
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="matrix.per_booking_add_ons.length > 0">
  <label><b>Per-Booking Add-Ons</b></label>

  <table class="table table-sm table-bordered">
    <tr *ngFor="let addOn of matrix.per_booking_add_ons">
      <th>
        {{ addOn.name }}
      </th>
      <td>
        {{ orgConfig.getCurrencySymbol() }}{{ addOn.fee }}
        <ng-container *ngIf="addOn.included_participants">
          (Max {{ addOn.included_participants }} Participants)
          <ng-container *ngIf="addOn.additional_participant_fee">
            <br>
            {{ orgConfig.getCurrencySymbol() }}{{ addOn.additional_participant_fee }} Per Additional Participant
          </ng-container>
        </ng-container>
        <ng-container *ngIf="addOn.allow_multiple_copies">
          <br>
          <span class="text-muted">
            Allows multiple copies (max {{ addOn.max_copies }},
            via {{ addOn.multiple_copies_input_type === 'dropdown' ? 'dropdown' : 'number input' }})
          </span>
        </ng-container>
      </td>
    </tr>
  </table>
</ng-container>

<p>
  <b>Per-Booking Deposit</b>:
  <ng-container *ngIf="matrix.per_booking_deposit !== null">{{ orgConfig.getCurrencySymbol() }}{{ matrix.per_booking_deposit }}</ng-container>
  <ng-container *ngIf="matrix.per_booking_deposit === null">None</ng-container>
</p>

<p><b>Vouchers <ng-container *ngIf="!matrix.vouchers_include_entry">do not</ng-container> include entry</b></p>
